import { render, staticRenderFns } from "./MaterialRatesList.vue?vue&type=template&id=d4427190&"
import script from "./MaterialRatesList.js?vue&type=script&lang=js&"
export * from "./MaterialRatesList.js?vue&type=script&lang=js&"
import style0 from "./MaterialRatesList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports